var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_443_14147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8968 16.9793C36.9177 17.2761 36.9177 17.5728 36.9177 17.8723C36.9177 26.998 29.8418 37.5227 16.9034 37.5227V37.5172C13.0813 37.5227 9.33865 36.4478 6.12109 34.421C6.67687 34.4867 7.2354 34.5196 7.79533 34.521C10.9628 34.5237 14.0396 33.4802 16.5315 31.5588C13.5215 31.5026 10.882 29.5758 9.95988 26.7628C11.0143 26.9625 12.1007 26.9214 13.1356 26.6438C9.85402 25.9929 7.49309 23.1619 7.49309 19.8744C7.49309 19.8443 7.49309 19.8156 7.49309 19.7868C8.47088 20.3215 9.56569 20.6184 10.6856 20.6512C7.59476 18.6232 6.64203 14.5861 8.50849 11.4298C12.0798 15.7444 17.3491 18.3674 23.0056 18.645C22.4387 16.2463 23.2132 13.7327 25.0406 12.0466C27.8736 9.4318 32.3296 9.56583 34.9927 12.3461C36.568 12.0411 38.0779 11.4736 39.4596 10.6694C38.9346 12.2681 37.8355 13.6261 36.3674 14.489C37.7618 14.3276 39.124 13.9611 40.4068 13.4018C39.4624 14.7912 38.2728 16.0015 36.8968 16.9793Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_443_14147",
    x: 6.12109,
    y: 10.1699,
    width: 34.2861,
    height: 27.3535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_443_14147"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.31f5fb55abd65aaa9c1f4a03c67eb656.svg";
export { ForwardRef as ReactComponent };